import React, { FC } from 'react';
import BlockWrapper from '@v2/pages/machines/modules/now/components/Overview/components/BlockWrapper';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import TopBlockHeader from './components/TopBlockHeader';
import TopBlockHeaderCard from './components/TopBlockHeaderCard';
import TopBlockSeparator from './components/TopBlockSeparator';
import TopBlockImages from './components/TopBlockImages';
import { BaseTopBlockProps, NCFileNameProp, OnTopBlockImagePressProp } from './types';

export interface SetupNCFileTopBlockProps extends BaseTopBlockProps, NCFileNameProp, OnTopBlockImagePressProp {}

const SetupNCFileTopBlock: FC<SetupNCFileTopBlockProps> = ({ C, ncFileName, onTopBlockImagePress }) => {
  return (
    <BlockWrapper testID={TEST_IDS.liveScreen.topBlockSetup} containerStyle={{ flex: 1, paddingHorizontal: 0 }}>
      <TopBlockHeaderCard C={C}>
        <TopBlockHeader C={C} ncFileName={ncFileName} />
      </TopBlockHeaderCard>

      <TopBlockSeparator C={C} />

      <TopBlockImages onTopBlockImagePress={onTopBlockImagePress} />
    </BlockWrapper>
  );
};

export default SetupNCFileTopBlock;
